import React from 'react';
import { graphql } from 'react-relay';
import classes from './PollList.module.scss';
import clsx from 'clsx';
import { PollList_polls$key } from './__generated__/PollList_polls.graphql';

import PollItem from '../PollItem/PollItem';
import { useRefetchableLiveFragment } from '../../../relay/useLiveFragment';
import useRefreshInFocus from '../../../hooks/useRefreshInFocus';

export interface Props {
  pollsRef: PollList_polls$key;
  className?: string;
}

const fragmentSpec = graphql`
  fragment PollList_polls on PollConnection @refetchable(queryName: "PollListRefetchQuery") {
    edges {
      node {
        id
        ...PollItem_poll
      }
    }
  }
`;

const PollList: React.FC<Props> = ({ pollsRef, className }) => {
  const [polls, refetch] = useRefetchableLiveFragment(fragmentSpec, pollsRef);

  const handleRefetch = React.useCallback(() => {
    refetch({}, { fetchPolicy: 'store-and-network' });
  }, [refetch]);

  useRefreshInFocus(handleRefetch, 10 * 60 * 1000);

  return (
    <ul className={clsx(classes.root, className)}>
      {polls?.edges.map((pollEdge) => (
        <li key={pollEdge.node.id} className={classes.pollLi}>
          <PollItem pollRef={pollEdge.node} />
        </li>
      ))}
    </ul>
  );
};

export default PollList;
